export const CLP_PAGE_ESPOT_PLACEHOLDER_2 = 'CLP_PAGE_ESPOT_PLACEHOLDER_2';
export const CLP_PAGE_ESPOT_3_MIN_TILES = 8;
export const DEFAULT_CATEGORIES_SIZE = 12;
